
export default function ProductCTA() {
  return (
    <section className="py-16 bg-gradient-to-br from-red-600 to-red-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-white mb-4">
            Ready to Enhance Your Fire Safety?
          </h2>
          <p className="text-xl text-red-100 max-w-3xl mx-auto">
            Get expert consultation and competitive quotes for our dry chemical extinguishers. Our team is ready to help you choose the right fire protection solution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="text-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-phone-line text-white text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Call Us</h3>
            <p className="text-red-100 mb-3">Speak with our fire safety experts</p>
            <a 
              href="tel:+97455544093"
              className="text-white hover:text-red-200 font-medium transition-colors"
            >
              +974 5554 4093
            </a>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-mail-line text-white text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Email Quote</h3>
            <p className="text-red-100 mb-3">Get detailed pricing and specifications</p>
            <a 
              href="/contact"
              className="text-white hover:text-red-200 font-medium transition-colors"
            >
              Request Quote
            </a>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-calendar-line text-white text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Site Visit</h3>
            <p className="text-red-100 mb-3">Schedule a consultation visit</p>
            <a 
              href="/contact"
              className="text-white hover:text-red-200 font-medium transition-colors"
            >
              Book Visit
            </a>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href="/contact"
            className="bg-white hover:bg-gray-100 text-red-600 px-8 py-4 rounded-lg font-semibold transition-colors text-center whitespace-nowrap"
          >
            <i className="ri-mail-line mr-2"></i>
            Get Free Quote
          </a>
          <a 
            href="https://wa.me/97455544093"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg font-semibold transition-colors text-center whitespace-nowrap"
          >
            <i className="ri-whatsapp-line mr-2"></i>
            WhatsApp Us
          </a>
        </div>

        {/* Trust Indicators */}
        <div className="mt-12 pt-8 border-t border-red-500/30">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-center">
            <div>
              <div className="text-2xl font-bold text-white mb-1">500+</div>
              <div className="text-red-200 text-sm">Projects Completed</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-white mb-1">24/7</div>
              <div className="text-red-200 text-sm">Emergency Support</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-white mb-1">QCDD</div>
              <div className="text-red-200 text-sm">Certified Products</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-white mb-1">2 Years</div>
              <div className="text-red-200 text-sm">Product Warranty</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
